import { http } from './client'
import type {
  DownloadCreatedResponse,
  DownloadRequest,
  JobResponse,
  ProbeRequest,
  ProbeResponse,
  Uuid,
} from './types'

export const probeUrl = (body: ProbeRequest) =>
  http.post<ProbeResponse>('/v0/downloads/probe', body)

export const createDownload = (body: DownloadRequest) =>
  http.post<DownloadCreatedResponse>('/v0/downloads/', body)

export const listJobs = () => http.get<JobResponse[]>('/v0/downloads/')

export const getJob = (id: Uuid) => http.get<JobResponse>(`/v0/downloads/${id}`)

export const deleteJob = (id: Uuid) => http.del<void>(`/v0/downloads/${id}`)
